import React from "react";
import "../assets/transactions/TransactionForm.css";

const TransactionForm = () => {
  return (
    <div className="transaction-container">
      <h2>Transaction Form</h2>

      {/* Payment Details */}
      <form action="" className="transaction-payment-details">
        <h4><i class="fa-solid fa-credit-card"></i> Payment Details</h4>
        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Account Number</label>
              <input type="text" placeholder="Enter account number" />
            </div>

            <div className="payment-details-inputs">
              <label>Transaction Amount</label>
              <input type="text" placeholder="Enter amount" />
            </div>
          </div>


          {/* Row 2 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Available Balance</label>
              <input type="text" readOnly />
            </div>

            <div className="payment-details-inputs">
              <label>Transaction Mode</label>
              <select name="" id="">
                <option value="Select Transaction Mode">Select Transacction Mode </option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Cheque">Cheque</option>
              </select>
            </div>
          </div>

          {/* Row 3 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Transaction Date</label>
              <input type="date" />
            </div>

            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select name="" id="">
                <option value="Select Payment Mode">Select Payment Mode </option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Cheque">Cheque</option>
              </select>
            </div>
          </div>
        </div>
        <div className="pay-btn">
            <button>Pay</button>
        </div>
      </form>

      {/* Account Details and Customer Details */}
      <div className="account-and-customer-section">
         {/* Account Details */}
      <div className="transaction-account-details">
        <h4><i class="fa-solid fa-building-columns"></i> Account Details</h4>
        <table>
          <tr>
            <th><i class="fa-solid fa-hashtag"></i> Account Number</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-building-columns"></i> Account Type</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-layer-group"></i> Scheme Name</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-percent"></i> ROI</th>
            <td>2345678</td>
          </tr>
        </table>
      </div>

      {/* Customer Details */}
      <div className="transaction-customer-details">
        <h4><i class="fa-solid fa-user"></i> Customer Details</h4>
          <table>
          <tr>
            <th><i class="fa-solid fa-user"></i> Customer Name</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-regular fa-address-card"></i> Customer ID</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-user-shield"></i> Guardian/Father/husband/CareOf</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-id-card"></i> Adhar</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-id-badge"></i> Pan</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-phone"></i> Mobile</th>
            <td>2345678</td>
          </tr>
          <tr>
            <th><i class="fa-solid fa-location-dot"></i> Address</th>
            <td>2345678</td>
          </tr>
        </table>
      </div>
      </div>
    </div>
  );
};

export default TransactionForm;
